import { Button, Col, Container, Image, Row } from 'react-bootstrap';
import Tabs from './Tabs/Tabs';
import RightSideImage from 'assets/img/landing/codeEngineOne.svg';
import BookDemoModal from 'components/modals/BookDemoModal';
import { useState } from 'react';

function Assessment() {
  const [show, setShow] = useState(false);
  const Rounds = () => {
    return (
      <Row>
        <Col
          lg={5}
          className="d-flex flex-column justify-content-center align-items-start"
        >
          <p className="text-warning-darker fs-8">
            Get in Touch with Crud beat
          </p>
          <p className="fs-4 fw-semibold">
            Comprehensive Tools for Hiring and Skill Development
          </p>
          <p className="text-body-quaternary">
            Advanced Recruitment Tools: Efficiently screen and evaluate
            candidates with our state-of-the-art technology.
          </p>
          <Button
            variant="primary"
            className="px-6 py-3 rounded-4 mt-4"
            onClick={() => setShow(true)}
          >
            Get Free Trail
          </Button>
        </Col>
        <Col lg={7}>
          <div className="w-100 rounded-5 ps-lg-14" style={{ height: '500px' }}>
            <Image
              src={RightSideImage}
              alt="RightImage"
              className="w-100 h-100 img-cover pt-sm-8 pt-lg-0 pt-8"
            />
          </div>
        </Col>
      </Row>
    );
  };

  const steps = [
    { label: 'Multiple Rounds', component: <Rounds /> },
    { label: 'Coding Assessment', component: <Rounds /> },
    { label: 'Realistic Video Interviews', component: <Rounds /> },
    { label: 'Auto Evaluation', component: <Rounds /> }
  ];

  return (
    <Container fluid className="p-lg-9 pt-9">
      <BookDemoModal show={show} onClose={() => setShow(false)} />
      <p className="fs-5 fw-bold text-center leading-2">
        One-stop Solution for Pre-employment <br /> Assessment
      </p>
      <p className="text-body-secondary text-center pb-5">
        Spanning innovative startups to established enterprises.
      </p>
      <Tabs steps={steps} />
      <Container fluid>
        <Row className="mt-14">
          <Col lg={7}>
            <div
              className="w-100 rounded-5 pe-lg-14"
              style={{ height: '500px' }}
            >
              <Image
                src={RightSideImage}
                alt="RightImage"
                className="w-100 h-100 img-cover pb-sm-8 pb-lg-0 pb-8"
              />
            </div>
          </Col>
          <Col
            lg={5}
            className="d-flex flex-column justify-content-center align-items-start"
          >
            <p className="text-warning-darker fs-8">
              Solutions for Recruitment and Skill Growth
            </p>
            <p className="fs-4 fw-semibold">
              Tailored Solutions for Recruitment and Skill Growth
            </p>
            <p className="text-body-quaternary">
              Precision Hiring Tools: Utilize our advanced algorithms to find
              and recruit developers who perfectly match your needs, minimizing
              time-to
            </p>
            <Button
              variant="primary"
              className="px-6 py-3 rounded-4 mt-4"
              onClick={() => setShow(true)}
            >
              Get Free Trail
            </Button>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Assessment;
